module.exports = __webpack_public_path__ + "static/media/war_bg.5fa774a1.png";